// @ts-expect-error untyped module
import LanguageSelect from 'ui-addon-i18n/components/LanguageSelect';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useSearchParams } from '../../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function LanguageFilter({
  filter
}) {
  const params = useSearchParams();
  if (!filter) return null;
  const id = `eco_${filter.field}`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: id,
      marginBlockStart: "200",
      children: filter.label
    }), /*#__PURE__*/_jsx(LanguageSelect, {
      id: id,
      multi: true,
      onChange: e => params.setList(filter.field, e.target.value),
      placeholder: filter.placeholder,
      value: params.getList(filter.field)
    })]
  });
}